import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'epay-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent implements OnInit {
  pagetitle = 'Contact Information';
  chaturl = '';

  chatLive!: boolean;
  currentTime!: any;

  constructor(private datePipe: DatePipe) {
    //this.chaturl = CommonSettings.ChatUrl;
    
  }

  ngOnInit(): void {
    //console.log("CHAT ", this.chaturl)

    this.checkBusinessHours();
  }

  openChat() {
    window.open('https://home-c29.incontact.com/incontact/chatclient/chatclient.aspx?poc=90279247-0e43-47e6-9586-026666c2277c&bu=4597186', '', 'width=510, height=900');
  }

  checkBusinessHours() {
    var currentCalendar = new Date();
    var year = currentCalendar.getFullYear();
    var month = currentCalendar.getMonth();
    var day = currentCalendar.getDate();
    //console.log("HERE ", year + " " + month + " " + day)

    var businessOpen = new Date(Date.UTC(year, month, day, 14, 0, 0));
    //businessOpen.setHours(8, 0, 0); //8:00AM MST or 10:00AM EST
    console.log("BUSINESS OPEN: ", businessOpen)
    //this.datePipe.transform(businessOpen, 'EEEE h:mm:ss a zzzz | +0600'); // Day Time Timezone


    var businessClose = new Date(Date.UTC(year, month, day, 24, 0, 0));
    //businessClose.setHours(18, 0, 0); //6:00PM MST or 8:00PM EST
    //this.datePipe.transform(businessClose, 'EEEE h:mm:ss a zzzz | +0600'); // Day Time Timezone
    console.log("BUSINESS CLOSE: ", businessClose)

    var currentTime = new Date();
    //var currentTimeOffset = currentTime.getTimezoneOffset();
    //currentTimeOffset = currentTimeOffset / 60;
    this.datePipe.transform(currentTime, 'EEEE h:mm:ss a zzzz'); // Day Time Timezone
    console.log("CURRENT TIME: ", currentTime);

    var currentDay = currentTime.toString().split(' ')[0];

    if (currentDay === "Sat" || currentDay === "Sun") {
      this.chatLive = false;
    }
    else {
      if (currentTime >= businessOpen && currentTime <= businessClose) {
        this.chatLive = true;
      }
      else {
        this.chatLive = false;
      }
    }
  }
}
